// extracted by mini-css-extract-plugin
module.exports = {"selectOption":"card_selectOption__3jWES","size":"card_size__2Hbtd","selectedCardDelete":"card_selectedCardDelete__2vQQm"};